import Swal from 'sweetalert2';

export const showSuccess = (message) => {
  Swal.fire({
    icon: 'success',
    title: 'Sucesso',
    text: message,
  });
};

export const showError = (message) => {
  Swal.fire({
    icon: 'error',
    title: 'Erro',
    text: message,
  });
};

export const showConfirmation = async ({
  title,
  text,
  confirmText = 'Sim',
  cancelText = 'Cancelar',
}) => {
  const result = await Swal.fire({
    title,
    text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
  });

  return result.isConfirmed;
};
